import FormSwitcher from './containers/FormSwitcher';
import projectSpecificBundle from './i18n/customization.bundle';
import { buildApp } from '../app';
import './styles/styles.scss';
import PrintView from './views/SummaryView/PrintView';
// eslint-disable-next-line import/order
import Cookies from 'js-cookie';

const url = new URL(window.location.href);

try {
  Cookies.remove('sessionId');
} catch (e) {
  console.error('Failed to remove sessionId cookie:', e);
}

if (url.searchParams.has('printId')) {
  buildApp(PrintView, projectSpecificBundle);
} else {
  buildApp(FormSwitcher, projectSpecificBundle);
}
